import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { MotionConfig } from "motion/react";

import App from "@/App";
import { TooltipProvider } from "@/components/ui/tooltip";
import "@/global.css";
import { initFontScale } from "@/store/useFontScaleStore";

initFontScale();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      throwOnError: false,
      retry: 0,
      // Cache data for 5 minutes to prevent excessive API calls
      staleTime: 5 * 60 * 1000,
      // Don't refetch on window focus to prevent OPTIONS spam
      refetchOnWindowFocus: false,
      // Don't refetch on window reconnect
      refetchOnReconnect: false,
    },
    mutations: {
      throwOnError: false,
    },
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      {/* 운영체제에서 "동작 줄이기"를 켠 사용자에게는 Motion 애니메이션을 끈다. */}
      <MotionConfig reducedMotion="user">
        <TooltipProvider>
          <App />
        </TooltipProvider>
      </MotionConfig>
      {/*{import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}*/}
    </QueryClientProvider>
  </StrictMode>,
);
